export const mapById = <T extends { id: string }>(
  data?: T[] | null,
): { [key: string]: T } =>
  Object.fromEntries((data ?? []).map((d) => [d.id, d]));
